
import { Toast, PullRefresh, SwipeCell, Dialog, Uploader, Popup } from "vant";
import md5 from "js-md5";
Vue.use(Uploader);
Vue.use(Popup);
import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import Compressor from "compressorjs";
import NavBar from "@/components/navBar.vue";
import { authidcard, authLimit } from "@/req/user";
@Component({
  components: { PullRefresh, SwipeCell, NavBar },
})
export default class Logout extends Vue {
  public count = 0;
  public isLoading = false;
  public data: any = {};
  public name = "";
  public idcard = "";
  public fontFile: any = []; // 身份证正面文件
  public backFile: any = []; // 身份证背面文件
  public fontNext = "0"; // 是否已上传正面
  public backNext = "0"; // 是否已上传背面
  public fontCamera = ""; // 是否唤起摄像头
  public backCamera = ""; // 是否唤起摄像头
  public show = false; // 展示弹出层
  public uploaderClickType: any = ""; // 点击了哪个上传组件

  public frontId = ""; // 身份证正面识别ID
  public backId = ""; // 身份证背面识别id
  public idcardFront = ""; // 身份证正面oss地址
  public idcardBack = ""; // 身份证反面oss地址
  public limit = 1;

  //   @Watch("code")
  //   public codeChange() {
  //       this.
  //   }

  public mounted() {
    this.getAuthLimit();
  }

  public async getAuthLimit() {
    const res = await authLimit();
    if (res.code === 200) {
      this.limit = res.data;
    }
  }

  public onClickLeft() {
    this.$router.go(-1);
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public showPopup(type) {
    this.show = true;
    this.uploaderClickType = type;
  }
  public uploaderClick(val) {
    if (this.uploaderClickType == 1) {
      this.fontCamera = val;
      (this as any).$refs.fontUpload.chooseFile();
    } else {
      this.backCamera = val;
      (this as any).$refs.backUpload.chooseFile();
    }
  }
  // 上传前处理图片
  public beforeRead(file) {
    // console.log(file);
    return new Promise((resolve, reject) => {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        resolve(file);
      } else {
        return new Compressor(file, {
          quality: 0.8,
          success: (res: any) => {
            res = new File([res], res.name, {
              type: res.type,
              lastModified: Date.now(),
            });
            // console.log(res);
            resolve(res);
          },
        });
      }
    });
  }
  public async afterRead(files) {
    // console.log(files);
    // 设置请求头为上传文件
    const configs = {
      headers: { "Content-Type": "multipart/form-data;charset=UTF-8" },
    };
    const forms = new FormData();
    forms.append("module", "idcard");
    forms.append("base64", files.content);
    forms.append("file", files.file);
    this.fontFile[0].status = "uploading";
    this.fontFile[0].message = "上传中...";
    axios
      .post(this.$HTTP_API.user.imageUpload, forms, configs)
      .then((response) => {
        // console.log(response);
        this.fontFile[0].url =
          response.data.data.info.domian + "/" + response.data.data.info.url;
        this.fontFile[0].status = "";
        this.fontFile[0].message = "";

        this.getInfo(1, response.data.data.info.url);
      })
      .catch((error) => {
        // console.log(error);
        this.fontFile[0].status = "failed";
        this.fontFile[0].message = "上传失败";
      });
  }
  public async afterReadB(files) {
    // console.log(files);
    // 设置请求头为上传文件
    const configs = {
      headers: { "Content-Type": "multipart/form-data;charset=UTF-8" },
    };
    const forms = new FormData();
    forms.append("module", "idcard");
    forms.append("base64", files.content);
    forms.append("file", files.file);
    this.backFile[0].status = "uploading";
    this.backFile[0].message = "上传中...";
    axios
      .post(this.$HTTP_API.user.imageUpload, forms, configs)
      .then((response) => {
        // console.log(response);
        this.backFile[0].url =
          response.data.data.info.domian + "/" + response.data.data.info.url;
        this.backFile[0].status = "";
        this.backFile[0].message = "";

        this.getInfo(2, response.data.data.info.url);
      })
      .catch((error) => {
        // console.log(error);
        this.backFile[0].status = "failed";
        this.backFile[0].message = "上传失败";
      });
  }
  // 身份证照片获取身份证信息
  public async getInfo(types, url) {
    const obj = {
      idcard_front: url,
      type: types,
    };
    const res = await authidcard(obj);
    if (res.code == 200) {
      Toast(res.msg);
      if (types == 1) {
        this.fontNext = "1";
        this.data.frontId = res.data.id;
        this.data.idcardFront = url;
        this.data.idcard = res.data.info.idcard;
        this.data.name = res.data.info.name;
      } else {
        this.backNext = "1";
        this.data.backId = res.data.id;
        this.data.idcardBack = url;
      }
    } else {
      if (types == 1) {
        this.fontFile[0].status = "failed";
        this.fontFile[0].message = res.msg;
      } else {
        this.backFile[0].status = "failed";
        this.backFile[0].message = res.msg;
      }
    }
  }
  // 下一步
  public next() {
    if (this.fontNext == "0" || this.backNext == "0") {
      Dialog.alert({
        title: " ",
        message: "无法识别，请重新上传",
        confirmButtonColor: "#000",
      }).then(() => {
        // on close
      });
      return;
    }
    if (
      this.$store.state.user.info.real_name &&
      this.$store.state.user.info.idcardmd5 != md5(this.data.idcard) &&
      this.$store.state.user.info.real_name != this.data.name
    )
      return Toast("身份证信息和已实名的信息不一致");
    this.$router.push({
      name: "authenticationconfirm",
      query: {
        data: encodeURI(JSON.stringify(this.data)),
      },
    });
  }
}
